import React from 'react';
import Grid from '@mui/material/Grid2';
import {
    Box,
    FormControlLabel,    
    Checkbox,
    FormLabel,
    TextField,
    RadioGroup,
    Radio,
    Button,
    Typography,
    Dialog, 
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

import './Questionnaire.css';
import { Formik } from 'formik';
import * as Yup from "yup";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

/*
const validationSchema = Yup.object({
    type_of_request: Yup.string().required("Type of Request is required"),
    admission_due_to_emergency_hold: Yup.string().required("This field is required"),
    admission_court_ordered: Yup.string().required("This field is required"),
    request_for_urgent_review: Yup.boolean(),

    facility_information: Yup.object({
        person_completing_form: Yup.string().required("Person completing form is required"),
        type: Yup.string().required("Facility type is required"),
        phone: Yup.string().matches(/^\d{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
        fax: Yup.string().matches(/^\d{10}$/, "Fax number must be 10 digits").required("Fax number is required"),
        facility_npi_tax_number: Yup.string().required("NPI/Tax Number is required"),
        facility_provider_id: Yup.string().required("Provider ID Number is required"),
        facility_name: Yup.string().required("Facility Name is required"),
        facility_address: Yup.string().required("Facility Address is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        zip: Yup.string().matches(/^\d{5}$/, "Zip code must be 5 digits").required("Zip code is required"),
    }),

    patient_information: Yup.object({
        member_name: Yup.string().required("Member Name is required"),
        gender: Yup.string().oneOf(["M", "F", "X"], "Invalid gender selection").required("Gender is required"),
        member_id: Yup.string().required("Member ID is required"),
        date_of_birth: Yup.date().required("Date of Birth is required"),
        member_address: Yup.string().required("Member Address is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        zip: Yup.string().matches(/^\d{5}$/, "Zip code must be 5 digits").required("Zip code is required"),
        phone: Yup.string().matches(/^\d{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
    }),

    inpatient_stay_information: Yup.object({
        is_initial_review: Yup.string().required("This field is required"),
        has_member_already_admitted: Yup.string().required("This field is required"),
        is_continued_stay_concurrent_review: Yup.string().required("This field is required"),
        admission_date: Yup.date().required("Admission date is required"),
        discharge_date: Yup.date().required("Discharge date is required"),
        admitting_individual_id: Yup.string().required("Individual ID is required"),
        npi_tax_number: Yup.string().required("NPI/Tax Number is required"),
        admitting_provider_name: Yup.string().required("Provider Name is required"),
        admitting_provider_address: Yup.string().required("Provider Address is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        zip: Yup.string().matches(/^\d{5}$/, "Zip code must be 5 digits").required("Zip code is required"),
        phone: Yup.string().matches(/^\d{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
        fax: Yup.string().matches(/^\d{10}$/, "Fax number must be 10 digits").required("Fax number is required"),
        primary_diagnosis_code: Yup.string().required("Primary diagnosis code is required"),
        secondary_diagnosis_code: Yup.string().required("Secondary diagnosis code is required"),
        is_surgical_admission: Yup.string().required("This field is required"),
        authorization_number: Yup.string().required("Authorization number is required"),
        medical_record_number: Yup.string().required("Medical record number is required"),
    }),

    provider_notes: Yup.string().required("Provider notes are required"),
    mental_health_evaluation: Yup.string().required("Mental health evaluation is required"),
});
*/

const validationSchema = Yup.object({
});


const Questionnaire = () => {

    const [open, setOpen] = React.useState(false);
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf", 
                        "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

    const handleFileChange = (event, fieldName, setFieldValue) => {
        const file = event.target.files[0];
        if (file && allowedTypes.includes(file.type)) {
            setFieldValue(fieldName, file); // Store in Formik state

        } else {
            alert("Only images, PDFs, and Word documents are allowed.");
            event.target.value = ""; // Reset the input
        }
    };

    const initialValues = {
        type_of_request: "",
        admission_due_to_emergency_hold: "",
        admission_court_ordered: "",
        request_for_urgent_review: false,
        facility_information: {
            person_completing_form: "",
            type: "",
            phone: "",
            fax: "",
            facility_npi_tax_number: "",
            facility_provider_id: "",
            facility_name: "",
            facility_address: "",
            city:"",
            state: "",
            zip: "",
        },
        patient_information: {
            member_name: "",
            gender: "",
            member_id: "",
            date_of_birth: dayjs(),
            member_address: "",
            city: "",
            state: "",
            zip: "",
            phone: ""
        },
        inpatient_stay_information: {
            is_initial_review: null,
            has_member_already_admitted: "",
            is_continued_stay_concurrent_review: "",
            admission_date: dayjs(),
            discharge_date: dayjs(),
            admitting_individual_id: "",
            npi_tax_number: "",
            admitting_provider_name: "",
            admitting_provider_address: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            fax: "",
            primary_diagnosis_code: "",
            secondary_diagnosis_code: "",
            is_surgical_admission: null,
            authorization_number: "",
            medical_record_number: ""
        },
        provider_notes: "",
        mental_health_evaluation: "",
    }

    function onFormSubmit(values, {resetForm}) {
        console.log('values', values)

        setOpen(true); // Open the dialog on successful submit
        resetForm(); // Reset form fields after submission

    }
    
      
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box component="section" className="headerBox">
                <Formik
                    initialValues={initialValues}
                    onSubmit={onFormSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                >
                    {(formikProps) => {
                    const {
                        values,
                        touched,
                        errors,
                        handleChange,
                        setFieldValue,
                        handleBlur,
                        handleSubmit,
                    } = formikProps;
                    return (

                        <form onSubmit={handleSubmit} noValidate>

                            {/** Main container */}
                            <Grid container className="container" spacing={2}>
                                <Grid item size={12}>

                                    {/** Type of Request */}
                                    <Grid container>
                                        <Grid item size={2} style={{display: 'flex', paddingTop: '10px', justifyContent: 'left'}}>
                                            <p style={{fontWeight: 'bold'}}>Type of Request: </p>
                                        </Grid>
                                        <Grid item size={10}>

                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={values?.type_of_request}
                                                name="type_of_request"
                                            >
                                                <Grid container>
                                                    <Grid item size={4}>
                                                        <FormControlLabel
                                                        control={<Radio color="primary"  value="Medical" />}
                                                        label="Medical"
                                                        />
                                                    </Grid>
                                                    <Grid item size={4}>
                                                        <FormControlLabel
                                                        control={<Radio color="primary"  value="Mental Health" />}
                                                        label="Mental Health"
                                                        />
                                                    </Grid>
                                                    <Grid item size={4}>
                                                        <FormControlLabel
                                                        control={<Radio color="primary"  value="Detox" />}
                                                        label="Detox"
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container>
                                                    <Grid item size={4}>
                                                        <FormControlLabel
                                                        control={<Radio color="primary"  value="Mental Health 23-hour Observation" />}
                                                        label="Mental Health 23-hour Observation"
                                                        />
                                                    </Grid>
                                                    <Grid item size={8}>
                                                        <FormControlLabel
                                                        control={<Radio color="primary"  value="Mental Health Residential Treatment Center" />}
                                                        label="Mental Health Residential Treatment Center"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </RadioGroup>


                                            <Grid container>
                                                <Grid item size={12}>
                                                        <p style={{fontSize: '13px'}}>*For LTAC, Inpatient Rehabilitation, SNF and Substance Use Disorder initial and continued stay reviews, please utilize the specific form. See page 2 for instructions.</p>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    {/** Admission Court Ordered */}
                                    <Grid container style={{marginTop: '20px'}}>
                                        <Grid item size={5} style={{display: 'flex', justifyContent: 'center'}}>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={values?.admission_court_ordered}
                                                name="admission_court_ordered"
                                                row
                                                style={{display: 'flex', alignItems: 'center'}}
                                            >
                                                <span className="inputLabel">Admission Court Ordered? &nbsp;</span>
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item size={5} style={{display: 'flex', justifyContent: 'center'}}>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={values?.admission_due_to_emergency_hold}
                                                name="admission_due_to_emergency_hold"
                                                row
                                                style={{display: 'flex', alignItems: 'center'}}
                                            >
                                                <span className="inputLabel">Admission due to emergency hold? &nbsp;</span>
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>

                                    <hr style={{margin:'15px', borderColor: '#004E87'}} />

                                    <Grid container>
                                        <Grid item>
                                            <Checkbox name="request_for_urgent_review" value={true} /> <strong>Request for Urgent Review: </strong> By clicking this box, I certify that applying the standard review time may serioiusly jeopardize the life or health of the member or the member's ability to regain maxium function per Federal definition of "Urgent".
                                        </Grid>
                                    </Grid>

                                    {/** Facility Information */}
                                    <Box component="fieldset" style={{marginTop: '20px', padding: '20px', borderRadius: '4px', borderColor: '#004E87'}}>
                                        <FormLabel component="legend" style={{color: "#004E87", fontSize: '14px', fontWeight: 'bold'}}>Facility Information</FormLabel>
                                        <Grid container spacing={2}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Person completing form" 
                                                    name="facility_information.person_completing_form"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.person_completing_form}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.person_completing_form && Boolean(errors?.facility_information?.person_completing_form)}
                                                    helperText={touched?.facility_information?.person_completing_form && errors?.facility_information?.person_completing_form}
                                                />
                                            </Grid>
                                            <Grid item size={6} style={{display: 'flex', justifyContent: 'left'}}>
                                                <RadioGroup
                                                    defaultValue={values?.facility_information?.type}
                                                    name="facility_information.type"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <FormControlLabel value="Clinic" control={<Radio />} label="Clinic" />
                                                    <FormControlLabel value="Facility" control={<Radio />} label="Facility" />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Phone" 
                                                    name="facility_information.phone"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.phone}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.phone && Boolean(errors?.facility_information?.phone)}
                                                    helperText={touched?.facility_information?.phone && errors?.facility_information?.phone}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="FAX" 
                                                    name="facility_information.fax"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.fax}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.fax && Boolean(errors?.facility_information?.fax)}
                                                    helperText={touched?.facility_information?.fax && errors?.facility_information?.fax}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Facility NPI/Tax Number" 
                                                    name="facility_information.facility_npi_tax_number"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.facility_npi_tax_number}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.facility_npi_tax_number && Boolean(errors?.facility_information?.facility_npi_tax_number)}
                                                    helperText={touched?.facility_information?.facility_npi_tax_number && errors?.facility_information?.facility_npi_tax_number}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                            <TextField 
                                                    label="Facility Provider ID Number" 
                                                    name="facility_information.facility_provider_id"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.facility_provider_id}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.facility_provider_id && Boolean(errors?.facility_information?.facility_provider_id)}
                                                    helperText={touched?.facility_information?.facility_provider_id && errors?.facility_information?.facility_provider_id}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={12}>
                                                <TextField 
                                                    label="Facility name" 
                                                    name="facility_information.facility_name"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.facility_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.facility_name && Boolean(errors?.facility_information?.facility_name)}
                                                    helperText={touched?.facility_information?.facility_name && errors?.facility_information?.facility_name}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={12}>
                                                <TextField 
                                                    label="Facility address" 
                                                    name="facility_information.facility_address"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.facility_address}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.facility_address && Boolean(errors?.facility_information?.facility_address)}
                                                    helperText={touched?.facility_information?.facility_address && errors?.facility_information?.facility_address}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="City" 
                                                    name="facility_information.city"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.city}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.city && Boolean(errors?.facility_information?.city)}
                                                    helperText={touched?.facility_information?.city && errors?.facility_information?.city}
                                                />
                                            </Grid>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="State" 
                                                    name="facility_information.state"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.state}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.state && Boolean(errors?.facility_information?.state)}
                                                    helperText={touched?.facility_information?.state && errors?.facility_information?.state}
                                                />
                                            </Grid>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="Zip" 
                                                    name="facility_information.zip"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.facility_information?.zip}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.facility_information?.zip && Boolean(errors?.facility_information?.zip)}
                                                    helperText={touched?.facility_information?.zip && errors?.facility_information?.zip}
                                                />
                                            </Grid>
                                        </Grid>

                                    </Box>

                                    {/** Patient Information */}
                                    <Box component="fieldset" style={{marginTop: '20px', padding: '20px', borderRadius: '4px', borderColor: '#004E87'}}>
                                        <FormLabel component="legend" style={{color: "#004E87", fontSize: '14px', fontWeight: 'bold'}}>Patient Information</FormLabel>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Member name" 
                                                    name="patient_information.member_name"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.member_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.member_name && Boolean(errors?.patient_information?.member_name)}
                                                    helperText={touched?.patient_information?.member_name && errors?.patient_information?.member_name}
                                                />
                                            </Grid>
                                            <Grid item size={6} style={{display: 'flex', justifyContent: 'left'}}>
                                                <RadioGroup
                                                    defaultValue={values?.patient_information?.gender}
                                                    name="patient_information.gender"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Gender: &nbsp;</span>
                                                    <FormControlLabel value="M" control={<Radio />} label="M" />
                                                    <FormControlLabel value="F" control={<Radio />} label="F" />
                                                    <FormControlLabel value="X" control={<Radio />} label="X" />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Member ID" 
                                                    name="patient_information.member_id"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.member_id}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.member_id && Boolean(errors?.patient_information?.member_id)}
                                                    helperText={touched?.patient_information?.member_id && errors?.patient_information?.member_id}
                                                />
                                            </Grid>
                                            <Grid item size={6} style={{display: 'flex', justifyContent: 'left'}}>

                                                <DesktopDatePicker
                                                    label="Date of Birth"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={values?.patient_information?.date_of_birth}
                                                    onChange={(value) => setFieldValue("patient_information.date_of_birth", value)}
                                                    maxDate={dayjs()}
                                                    renderInput={(params) => (
                                                        <TextField
                                                        {...params}
                                                        name="patient_information.date_of_birth"
                                                        fullWidth
                                                        error={touched?.patient_information?.date_of_birth && Boolean(touched?.patient_information?.date_of_birth)}
                                                        helperText={touched?.patient_information?.date_of_birth && touched?.patient_information?.date_of_birth}
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={12}>
                                                <TextField 
                                                    label="Member Address" 
                                                    name="patient_information.member_address"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.member_address}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.member_address && Boolean(errors?.patient_information?.member_address)}
                                                    helperText={touched?.patient_information?.member_address && errors?.patient_information?.member_address}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={3}>
                                                <TextField 
                                                    label="City" 
                                                    name="patient_information.city"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.city}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.city && Boolean(errors?.patient_information?.city)}
                                                    helperText={touched?.patient_information?.city && errors?.patient_information?.city}
                                                />
                                            </Grid>
                                            <Grid item size={3}>
                                                <TextField 
                                                    label="State" 
                                                    name="patient_information.state"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.state}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.state && Boolean(errors?.patient_information?.state)}
                                                    helperText={touched?.patient_information?.state && errors?.patient_information?.state}
                                                />
                                            </Grid>
                                            <Grid item size={3}>
                                                <TextField 
                                                    label="Zip" 
                                                    name="patient_information.zip"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.zip}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.zip && Boolean(errors?.patient_information?.zip)}
                                                    helperText={touched?.patient_information?.zip && errors?.patient_information?.zip}
                                                />
                                            </Grid>
                                            <Grid item size={3}>
                                                <TextField 
                                                    label="Phone" 
                                                    name="patient_information.phone"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.phone}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.phone && Boolean(errors?.patient_information?.phone)}
                                                    helperText={touched?.patient_information?.phone && errors?.patient_information?.phone}
                                                />
                                            </Grid>
                                        </Grid>

                                    </Box>



                                    {/** Inpatient Stay Information */}
                                    <Box component="fieldset" style={{marginTop: '20px', padding: '20px', borderRadius: '4px', borderColor: '#004E87'}}>
                                        <FormLabel component="legend" style={{color: "#004E87", fontSize: '14px', fontWeight: 'bold'}}>Inpatient Stay Information</FormLabel>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <RadioGroup
                                                    defaultValue={values?.inpatient_stay_information.is_initial_review}
                                                    name="inpatient_stay_information.is_initial_review"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Is this the initial review?: &nbsp;</span>
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid item size={6}>
                                                <RadioGroup
                                                    defaultValue={values?.inpatient_stay_information.has_member_already_admitted}
                                                    name="inpatient_stay_information.has_member_already_admitted"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Is yes, has the member already been admitted?: &nbsp;</span>
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={12}>
                                                <RadioGroup
                                                    defaultValue={values?.inpatient_stay_information.is_continued_stay_concurrent_review}
                                                    name="inpatient_stay_information.is_continued_stay_concurrent_review"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Is this a Continued stay/Concurrent review?: &nbsp;</span>
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>

                                                <DesktopDatePicker
                                                    label="Admission date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={values?.inpatient_stay_information?.admission_date}
                                                    onChange={(value) => setFieldValue("inpatient_stay_information.admission_date", value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                        {...params}
                                                        name="inpatient_stay_information.admission_date"
                                                        fullWidth
                                                        error={touched?.patient_information?.admission_date && Boolean(touched?.patient_information?.admission_date)}
                                                        helperText={touched?.patient_information?.admission_date && touched?.patient_information?.admission_date}
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                            <Grid item size={6}>

                                                <DesktopDatePicker
                                                    label="Discharge date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={values?.inpatient_stay_information?.discharge_date}
                                                    onChange={(value) => setFieldValue("inpatient_stay_information.discharge_date", value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                        {...params}
                                                        name="inpatient_stay_information.discharge_date"
                                                        fullWidth
                                                        error={touched?.patient_information?.discharge_date && Boolean(touched?.patient_information?.discharge_date)}
                                                        helperText={touched?.patient_information?.discharge_date && touched?.patient_information?.discharge_date}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Admitting/Attending Individual ID #" 
                                                    name="inpatient_stay_information.admitting_individual_id"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.admitting_individual_id}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.admitting_individual_id && Boolean(errors?.patient_information?.admitting_individual_id)}
                                                    helperText={touched?.patient_information?.admitting_individual_id && errors?.patient_information?.admitting_individual_id}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="NPI/Tax #" 
                                                    name="inpatient_stay_information.npi_tax_number"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.npi_tax_number}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.npi_tax_number && Boolean(errors?.patient_information?.npi_tax_number)}
                                                    helperText={touched?.patient_information?.npi_tax_number && errors?.patient_information?.npi_tax_number}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Admitting/Attending provider name" 
                                                    name="inpatient_stay_information.admitting_provider_name"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.admitting_provider_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.admitting_provider_name && Boolean(errors?.patient_information?.admitting_provider_name)}
                                                    helperText={touched?.patient_information?.admitting_provider_name && errors?.patient_information?.admitting_provider_name}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Admitting/Attending provider address" 
                                                    name="inpatient_stay_information.admitting_provider_address"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.patient_information?.admitting_provider_address}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.patient_information?.admitting_provider_address && Boolean(errors?.patient_information?.admitting_provider_address)}
                                                    helperText={touched?.patient_information?.admitting_provider_address && errors?.patient_information?.admitting_provider_address}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="City" 
                                                    name="inpatient_stay_information.city"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.city}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.city && Boolean(errors?.inpatient_stay_information?.city)}
                                                    helperText={touched?.inpatient_stay_information?.city && errors?.inpatient_stay_information?.city}
                                                />
                                            </Grid>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="State" 
                                                    name="inpatient_stay_information.state"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.state}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.state && Boolean(errors?.inpatient_stay_information?.state)}
                                                    helperText={touched?.inpatient_stay_information?.state && errors?.inpatient_stay_information?.state}
                                                />
                                            </Grid>
                                            <Grid item size={4}>
                                                <TextField 
                                                    label="Zip" 
                                                    name="inpatient_stay_information.zip"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.zip}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.zip && Boolean(errors?.inpatient_stay_information?.zip)}
                                                    helperText={touched?.inpatient_stay_information?.zip && errors?.inpatient_stay_information?.zip}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Phone" 
                                                    name="inpatient_stay_information.phone"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.phone}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.phone && Boolean(errors?.inpatient_stay_information?.phone)}
                                                    helperText={touched?.inpatient_stay_information?.phone && errors?.inpatient_stay_information?.phone}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Fax" 
                                                    name="inpatient_stay_information.fax"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.fax}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.fax && Boolean(errors?.inpatient_stay_information?.fax)}
                                                    helperText={touched?.inpatient_stay_information?.fax && errors?.inpatient_stay_information?.fax}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Primary diagnosis code" 
                                                    name="inpatient_stay_information.primary_diagnosis_code"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.primary_diagnosis_code}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.primary_diagnosis_code && Boolean(errors?.inpatient_stay_information?.primary_diagnosis_code)}
                                                    helperText={touched?.inpatient_stay_information?.primary_diagnosis_code && errors?.inpatient_stay_information?.primary_diagnosis_code}
                                                />
                                            </Grid>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Secondary diagnosis code" 
                                                    name="inpatient_stay_information.secondary_diagnosis_code"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.secondary_diagnosis_code}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.secondary_diagnosis_code && Boolean(errors?.inpatient_stay_information?.secondary_diagnosis_code)}
                                                    helperText={touched?.inpatient_stay_information?.secondary_diagnosis_code && errors?.inpatient_stay_information?.secondary_diagnosis_code}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <RadioGroup
                                                    defaultValue={values?.inpatient_stay_information?.is_surgical_admission}
                                                    name="inpatient_stay_information.is_surgical_admission"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Is this a surgical admission?: &nbsp;</span>
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid item size={6}>
                                                <RadioGroup
                                                    defaultValue={values?.inpatient_stay_information?.authorization_number}
                                                    name="inpatient_stay_information.authorization_number"
                                                    row
                                                    style={{display: 'flex', alignItems: 'center'}}
                                                >
                                                    <span className="inputLabel">Is yes, authorization number (if application) &nbsp;</span>
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} style={{marginTop: '20px'}}>
                                            <Grid item size={6}>
                                                <TextField 
                                                    label="Your medical record number" 
                                                    name="inpatient_stay_information.medical_record_number"
                                                    variant="outlined" 
                                                    fullWidth 
                                                    value={values?.inpatient_stay_information?.medical_record_number}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched?.inpatient_stay_information?.medical_record_number && Boolean(errors?.inpatient_stay_information?.medical_record_number)}
                                                    helperText={touched?.inpatient_stay_information?.medical_record_number && errors?.inpatient_stay_information?.medical_record_number}
                                                />
                                            </Grid>
                                        </Grid>


                                    </Box>

                                    {/** Attachment section */}
                                    <Box component="fieldset" style={{marginTop: '20px', padding: '20px', borderRadius: '4px', borderColor: '#004E87'}}>
                                        <FormLabel component="legend" style={{color: "#004E87", fontSize: '14px', fontWeight: 'bold'}}>Required Attachments</FormLabel>

                                        <Grid container>
                                            <Grid item size={6}>
                                                <span className="inputLabel">Comprehensive History and Physical Report: &nbsp;</span>
                                                <input
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
                                                    style={{ display: "none" }}
                                                    id="provider-notes-upload"
                                                    type="file"
                                                    onChange={(e) => handleFileChange(e, "provider_notes" , setFieldValue) }
                                                />
                                                <label htmlFor="provider-notes-upload">
                                                    <Button variant="contained" component="span">
                                                    Upload File
                                                    </Button>
                                                </label>
                                                {values?.provider_notes && (
                                                    <Typography variant="body1">Selected file: {values?.provider_notes?.name}</Typography>
                                                )}
                                            </Grid>
                                            <Grid item size={6}>
                                                <span className="inputLabel">Diagnostic Report: &nbsp;</span>
                                                <input
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
                                                    style={{ display: "none" }}
                                                    id="mental-health-eval-upload"
                                                    type="file"
                                                    onChange={(e) => handleFileChange(e, "mental_health_evaluation" , setFieldValue) }
                                                />
                                                <label htmlFor="mental-health-eval-upload">
                                                    <Button variant="contained" component="span">
                                                        Upload File
                                                    </Button>
                                                </label>
                                                {values?.mental_health_evaluation && (
                                                    <Typography variant="body1">Selected file: {values?.mental_health_evaluation?.name}</Typography>
                                                )}
                                            </Grid>
                                        </Grid>

                                    </Box>

                                    <Grid container style={{margin: '30px 0'}}>
                                        <Grid item size={12}>
                                            <Button color="primary" variant="contained"  type="submit">
                                                Submit Prior Authorization
                                            </Button>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </form>

                    );
                    }}
                    </Formik>


            </Box>

            {/* Success Dialog */}
            <Dialog open={open} onClose={() => setOpen(false)} sx={{ "& .MuiDialog-paper": { minWidth: "300px", minHeight: "150px" } }}>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Form Submitted
                    <IconButton onClick={() => setOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Form has been successfully submitted!
                    </DialogContentText>
                </DialogContent>
            </Dialog>


        </LocalizationProvider>
    )

}

export default Questionnaire;